var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookFIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 0C24.1962 0 25.4327 0.531793 26.4596 1.59538C27.4865 2.65896 28 3.93967 28 5.4375V23.5625C28 25.0603 27.4865 26.341 26.4596 27.4046C25.4327 28.4682 24.1962 29 22.75 29H19.3229V17.7663H22.9505L23.4974 13.3861H19.3229V10.5918C19.3229 9.88694 19.4657 9.35829 19.7513 9.00586C20.0369 8.65343 20.5929 8.47721 21.4193 8.47721L23.6432 8.45833V4.55013C22.8776 4.43685 21.796 4.38021 20.3984 4.38021C18.7457 4.38021 17.424 4.88368 16.4336 5.89063C15.4431 6.89757 14.9479 8.31988 14.9479 10.1576V13.3861H11.3021V17.7663H14.9479V29H5.25C3.80382 29 2.56727 28.4682 1.54036 27.4046C0.513455 26.341 0 25.0603 0 23.5625V5.4375C0 3.93967 0.513455 2.65896 1.54036 1.59538C2.56727 0.531793 3.80382 0 5.25 0H22.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFIcon);
export default __webpack_public_path__ + "static/media/facebook-f-icon.aa276a281e459b0aa5ef4a5f79cb4a1e.svg";
export { ForwardRef as ReactComponent };